import axiosInstance from "../../../core/api/axios";
import { favoriteFilterStore } from "../stores/favoriteFilterStore";
import { favoriteStore } from "../stores/favoriteStore";

export async function getFavorites() {
  try {
    const category = favoriteFilterStore.getState().category;
    const discipline = favoriteFilterStore.getState().discipline;
    const setFavorites = favoriteStore.getState().setFavorites;

    let disciplines = "all";
    let categories = "all";

    if(category.length > 0) {
      const auxC = category.join(',')

      categories = auxC
    }

    if(discipline.length > 0) {
      const auxD = discipline.join(',');

      disciplines = auxD
    }

    const { data } = await axiosInstance.get(`/favorites/all?category=${categories}&discipline=${disciplines}`)
    setFavorites(data);

    return data
  } catch(e: any) {
    throw new Error(e);
  }
}